<div id="layout" class="f_col">
  <app-view-title [chooseLangBtn]="true">{{'welcome.title_5.DYN.' | translate : {appName: api.env.name} }}</app-view-title>
  <div class="scroll_wrapper">
    <div class="parent-container">
      <app-view-deco-image class="mt_20 mb_20" [imageUrl]="api.env.useGuichet ? 'assets/images/image_online-ad.svg' : 'assets/images/image_heart.svg'"></app-view-deco-image>
      <div class="welcome-text text_center">
        <p [innerHTML]="'welcome.text_5.DYN.'  | translate : {appName: env.name}"></p>
      </div>
    </div>
    <div class="btns-container">
      <div class="fullWidth flex f_center">
        <div class="menuButton-container flex f_center">
          <div class="flex gap_10">
            <app-back-btn class="resp_maxSize_l" icon="arrow-left" (btnClicked)="nav.to(api.userRole.isCustomer ? 'welcome-explain' : 'welcome-offline')"></app-back-btn>
            <app-button color="transparent" border="true" size="xsm" type="submit" formId="form" class="fullWidth child-btn resp_minSize_l" (btnClicked)="nav.to(api.userRole.isCustomer ? 'welcome-explain' : 'welcome-offline')">{{'global.previous' | translate}}</app-button>
          </div>
          <div class="ml_10 fullWidth">
            <app-button type="submit" formId="form" class="fullWidth child-btn resp_maxSize_l" (btnClicked)="close()">{{'global.next' | translate}}</app-button>
            <app-button size="xsm" type="submit" formId="form" class="fullWidth child-btn resp_minSize_l" (btnClicked)="close()">{{'global.close' | translate}}</app-button>
          </div>
        </div>
      </div>
    </div>


    </div>
</div>
